import { render, staticRenderFns } from "./ed-list-homework-sections.vue?vue&type=template&id=2ca163e1&scoped=true&"
import script from "./ed-list-homework-sections.ts?vue&type=script&lang=ts&"
export * from "./ed-list-homework-sections.ts?vue&type=script&lang=ts&"
import style0 from "./ed-list-homework-sections.scss?vue&type=style&index=0&id=2ca163e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca163e1",
  null
  
)

export default component.exports